/* eslint-disable import/prefer-default-export */
import { RootState } from 'redux/schemas';

export const getPointsConfiguration = (
  state: RootState,
  pointsConfigurationId: number,
) => state.models.pointsConfigurations[pointsConfigurationId?.toString()];
